var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.25 128H215.75C123.125 128 48 203.125 48 295.75V344.25C48 436.875 123.125 512 215.75 512H232.25C324.875 512 400 436.875 400 344.25V295.75C400 203.125 324.875 128 232.25 128ZM384 344.25C384 427.926 315.926 496 232.25 496H215.75C132.074 496 64 427.926 64 344.25V295.75C64 212.074 132.074 144 215.75 144H232.25C315.926 144 384 212.074 384 295.75V344.25ZM440 0H8C3.594 0 0 3.578 0 8S3.594 16 8 16H440C444.406 16 448 12.422 448 8S444.406 0 440 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverline);
export default __webpack_public_path__ + "static/media/overline.4e4954431038e52d9ca66f58a3d127c5.svg";
export { ForwardRef as ReactComponent };